module.exports = __webpack_public_path__ + "images/jumpstart-hero-bg.jpg";